import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Input as BaseInput } from '@mui/base/Input';
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";
import { addTaggingHistory, fetchTaggingOptions } from "../../../api/tagging";
import { toast } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";

const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const Tagging = () => {


    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Tagging'))

    const [showList, setShowList] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const [options, setOptions] = useState({
        invoice_amount: '',
        payment_number: null,
        payment_amount: '',
        remaining_amount: '',
    });
    const [invoiceList, setInvoiceList] = useState([]);
    const [paymentTerms, setPaymentTerms] = useState([]);
    const [selectedPO, setSelectedPO] = useState(null);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [taggingOptions, setTaggingOptions] = useState([]);
    const [approvalrows, setApprovalRows] = useState([]);
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [message, setMessage] = useState("Successfully created the Tagging")

   
    const Input = React.forwardRef(function CustomInput(props, ref) {
        return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
    });
    document.title = "Dashboard | Procurement Dashboard";

        const columns = [
            {
                field: 'Sl_No', headerName: 'Sl.No', flex: .5,
                resizable: false,
                sortable: false,
            },
            {
                field: 'po_no',
                headerName: 'Po No.',
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },
            {
                field: 'invoice_no',
                headerName: 'Invoice No.',
                headerClassName: 'table-header-background',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
            },
            {
                field: 'invoice_amount',
                headerName: 'Invoice Amount',
                headerClassName: 'table-header-background',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
            },
            {
                field: 'payment_no',
                headerName: 'Payment No.',
                headerClassName: 'table-header-background',
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            }, 
            {
                field: 'payment_amount',
                headerName: 'Payment Amount',
                headerClassName: 'table-header-background',
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },  
            {
                field: 'remaining_amount',
                headerName: 'Remaining Amount',
                headerClassName: 'table-header-background',
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },
        ];
    
   
    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);

    const fetchTaggingOptionsFromBackend = async () => {
        try {

          const response = await fetchTaggingOptions();

          setTaggingOptions(response.data.details.map((item) => ({...item, label:item.PONUMBER})));

        } catch (error) {
          toast.error("Error in fetching tagging options");
          console.log(error);
        }
      };

      const handleInputChange = (value, input_name) => {
        let prev = {...options};
        prev[input_name] = value;

        if(input_name == 'payment_number'){
            prev['payment_amount'] = value.tagging_pending_amt;
            prev['remaining_amount'] = Math.abs(prev['invoice_amount'] - value.tagging_pending_amt);
        }

        setOptions(prev);
    }

    const handleSubmit = async () => {
        try {

           

            const payload = {
                erp_po_id: selectedInvoice.erp_po_id,
                invoice_id: selectedInvoice.id,
                invoice_amt: selectedInvoice.tagging_pending_amt,
                payment_id: options.payment_number.id,
                payment_amt: options.payment_number.tagging_pending_amt,
                remaining_amt: Math.abs(selectedInvoice.tagging_pending_amt - options.payment_number.tagging_pending_amt)
            }

            

            const response = await addTaggingHistory(payload);
            
            if(response.statusCode == 200){
                setMessage("Successfully created the Tagging");
                setIsOpenSweetAlert(true);
                setSelectedPO(null);
                fetchTaggingOptionsFromBackend();
            }


        } catch (error) {
            toast.error("Error in submitting Tagging data");
            console.log(error);
        }
    }

      useEffect(() => {
        fetchTaggingOptionsFromBackend();
      }, []);

      useEffect(() => {
        setSelectedInvoice(null);
        setPaymentTerms([]);
        setOptions({
            invoice_amount: '',
            payment_number: null,
            payment_amount: '',
            remaining_amount: '',
        });
        setInvoiceList([]);
        setApprovalRows([]);

        if(selectedPO){
            setInvoiceList(selectedPO.procurementInvoice.map(el => ({...el, label:el.invoice_number})));
            setPaymentTerms(selectedPO.procurementPayments.map(el => ({...el, label:el.payment_no})));
        }
      }, [selectedPO]);

    useEffect(() => {
        setOptions(prevOptions => ({
            ...prevOptions,
            invoice_amount: selectedInvoice ? selectedInvoice.tagging_pending_amt : '',
            payment_number: null,
            payment_amount: '',
            remaining_amount: '',
        }));
    
        setApprovalRows([]);
    
        if (selectedInvoice) {
            const newApprovalRows = selectedPO?.procurementTaggingHistory?.filter(el => el.invoice_id == selectedInvoice?.id)?.map((el, idx) => ({
                id: el.id,
                Sl_No: idx + 1,
                po_no: selectedPO.PONUMBER,
                invoice_no: selectedInvoice.label,
                invoice_amount: el.invoice_amt,
                payment_no: el.procurementPayments.payment_no,
                payment_amount: el.payment_amt,
                tagging_date: el.tagging_date
            })) || [];
    
            setApprovalRows(newApprovalRows);
        }
    }, [selectedInvoice, selectedPO]); 
    

      useEffect(() => {
        if(!options.payment_number){
            let prev = {...options};
            prev['payment_amount'] = '';
            prev['remaining_amount'] = '';
            setOptions(prev);
        }
      }, [options]);

    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <Card>
                            <CardBody>
                                <div>
                                    <div className='d-flex align-items-center  justify-content-between mb-2 gap-2 flex-wrap'>
                                        <div className="d-flex align-items-center gap-2">
                                            <p className='mb-0 me-2 requisition_type_text'>Tagging</p>
                                            <div>
                                            <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 230 }}
                                                options={taggingOptions}
                                                value={selectedPO}
                                                onChange={(e, value) => {
                                                    setSelectedPO(value);
                                                }}
                                                // onChange={handleProductCategoryChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Po"
                                                    />
                                                )}
                                            />

                                        </div>
                                        <div>
                                            <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 230 }}
                                                options={invoiceList}
                                                value={selectedInvoice}
                                                onChange={(e, value) => {
                                                    setSelectedInvoice(value);
                                                }}
                                                disabled={!selectedPO}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Invoice No"
                                                    />
                                                )}
                                            />

                                        </div>
                                        {/* <div>
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Invoice Amount"
                                                variant="outlined"
                                                value={options.invoice_amount}
                                                type='number'
                                                disabled={true}
                                                sx={{ width: 260 }}
                                            />
                                        </div>
                                        <div className="d-flex gap-2 align-items-center">
                                                <p className="mb-0" style={{color:'#545B69', fontSize:'15px', fontWeight:'500'}}>Total Invoice Amt :</p>
                                                <p className="mb-0" style={{ fontSize:'14px', fontWeight:'500'}}>{selectedInvoice?.invoice_total}</p>
                                            </div> */}
                                            </div>
                                    </div>
                                    <div className='d-flex align-items-center mb-2 gap-2 flex-wrap mt-3'>
                                        
                                        <div>
                                        {/* <Autocomplete
                                            className="invoice_autofield"
                                            // id={`product-category`}
                                            sx={{ width: 260 }}
                                            options={paymentTerms}
                                            value={options.payment_number}
                                            onChange={(e, value) => handleInputChange(value, 'payment_number')}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Payment Number"
                                                />
                                            )}
                                            disabled={!selectedPO || !selectedInvoice}
                                            
                                        /> */}
                                        <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Invoice Amount"
                                                variant="outlined"
                                                // value={row.quantity}
                                                value={options.payment_amount}
                                                type='number'
                                                disabled={true}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                sx={{ width: 250 }}
                                            />
                                        </div>
                                        <div>
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Select Payment Number"
                                                variant="outlined"
                                                // value={row.quantity}
                                                value={options.payment_amount}
                                                type='number'
                                                disabled={true}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                sx={{ width: 250 }}
                                            />
                                        </div>
                                        <div>
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Payment Amount"
                                                variant="outlined"
                                                value={options.remaining_amount}
                                                type='number'
                                                disabled={true}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                sx={{ width: 250 }}
                                            />
                                        </div>
                                        <div>
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Remaining Amount"
                                                variant="outlined"
                                                value={options.remaining_amount}
                                                type='number'
                                                disabled={true}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                sx={{ width: 250 }}
                                            />
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <button className="assign_vendor" disabled={!selectedPO || !selectedInvoice || !options.payment_number} onClick={handleSubmit}>Submit</button>
                                    </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <div>
                            <Box sx={{ height: '100%', width: '100%', marginBottom: '10px', marginTop: '10px' }}>
                                <DataGrid
                                    autoHeight
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={approvalrows}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 5,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box>
                        </div>
                    </div>
                </Container>
            </div>
            <SweetAlert
                show={isOpenSweetAlert}
                title={message}
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function
            />

        </React.Fragment>
    );
};

export default Tagging;
